import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('dashboard/requestCreatedChartData')
          .then(chartData => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.chartData = chartData

            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'Settings' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      chartData: route.params.chartData,
    }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => lazyLoadView(import('@views/forgotPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/admin/users',
    name: 'orgUsers',
    component: () => lazyLoadView(import('@views/orgUsers')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/currentUserCanManagePermissions']) {
          next({ name: 'home' })
        } else {
          // Continue to the orgUsers
          next()
        }
      },
    },
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: () => lazyLoadView(import('@views/resetPassword')),
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => lazyLoadView(import('@views/settings')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/currentUserCanManageSettings']) {
          next({ name: 'home' })
        } else {
          store
            // Try to fetch the user's information by their user_id
            .dispatch('settings/getSettings')
            .then(settings => {
              // Add the settings to the route params, so that it can
              // be provided as a prop for the view component below.
              routeTo.params.settings = settings

              // Continue to the route.
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Settings' } })
            })
        }
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      options: route.params.settings.options,
      fields: route.params.settings.fields,
      revUsageFields: route.params.settings.revUsageFields,
    }),
  },
  {
    path: '/workflow/:workflowId',
    name: 'editWorkflow',
    component: () => lazyLoadView(import('@views/editWorkflow')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/currentUserCanManageSettings']) {
          next({ name: 'home' })
        } else {
          if (routeTo.params.workflow) {
            next()
          } else {
            // read from API
            store
              .dispatch('approverWorkflow/getApprover', {
                workflowId: routeTo.params.workflowId,
              })
              .then(result => {
                routeTo.params.workflow = result.data
                // Continue to the route.
                next()
              })
              .catch(() => {
                // If a user with the provided username could not be
                // found, redirect to the 404 page.
                next({ name: '404', params: { resource: 'Workflow' } })
              })
          }
        }
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      workflow: route.params.workflow,
    }),
  },
  {
    path: '/c3',
    name: 'c3',
    component: () => lazyLoadView(import('@views/c3')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('cdmFields/getFields', { force: true })
          .then(result => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.fields = result
            // Continue to the route.
            store.dispatch('approverWorkflow/getApprovers').then(result => {
              routeTo.params.approverWorkflow = result
              // Continue to the route.
              next()
            })
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'CDMs' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      fields: route.params.fields,
      approvalWorkflows: route.params.approverWorkflow,
    }),
  },
  {
    path: '/cdms',
    name: 'cdms',
    component: () => lazyLoadView(import('@views/cdms')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('cdmFields/getFields', { force: true })
          .then(result => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.fields = result
            // Continue to the route.
            store.dispatch('approverWorkflow/getApprovers').then(result => {
              routeTo.params.approverWorkflow = result
              // Continue to the route.
              next()
            })
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'CDMs' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      fields: route.params.fields,
      approvalWorkflows: route.params.approverWorkflow,
    }),
  },
  {
    path: '/cdmrs',
    name: 'cdmrs',
    component: () => lazyLoadView(import('@views/cdmrs')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('cdmFields/getFields', { force: true })
          .then(result => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.fields = result
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'CDMs' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      fields: route.params.fields,
      queryListType: route.query.type,
    }),
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => lazyLoadView(import('@views/admin')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (
          !store.getters['auth/currentUserCanManageUsers'] ||
          !store.getters['auth/currentUserCanManageRoles'] ||
          !store.getters['auth/currentUserCanManagePermissions'] ||
          !store.getters['auth/currentUserCanManageSettings']
        ) {
          next({ name: 'home' })
        } else {
          store
            // Try to fetch the user's information by their user_id
            .dispatch('settings/getApproverWorkflows')
            .then(settings => {
              // Add the settings to the route params, so that it can
              // be provided as a prop for the view component below.
              routeTo.params.settings = settings
              // Continue to the route.
              next()
            })
            .catch(() => {
              // If a user with the provided username could not be
              // found, redirect to the 404 page.
              next({ name: '404', params: { resource: 'Approver Workflows' } })
            })
        }
      },
    },
    props: route => ({
      approverWorkflow: route.params.settings.approvers,
    }),
  },
  {
    path: '/admin/roles',
    name: 'orgRoles',
    component: () => lazyLoadView(import('@views/viewRoles')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/currentUserCanManageRoles']) {
          next({ name: 'home' })
        } else {
          // Continue to the orgUsers
          next()
        }
      },
    },
  },
  {
    path: '/admin/permissions',
    name: 'viewPermissions',
    component: () => lazyLoadView(import('@views/viewPermissions')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (!store.getters['auth/currentUserCanManagePermissions']) {
          next({ name: 'home' })
        } else {
          // Continue to the orgUsers
          next()
        }
      },
    },
  },
  {
    path: '/cdms/:cdmId',
    name: 'viewCdm',
    component: () => lazyLoadView(import('@views/viewCdm')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('cdm/getCdm', { cdmId: routeTo.params.cdmId })
          .then(result => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.cdm = result.cdm
            routeTo.params.fields = result.fields

            store.dispatch('approverWorkflow/getApprovers').then(result => {
              routeTo.params.approverWorkflow = result
              // Continue to the route.
              next()
            })
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'CDM' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      cdm: route.params.cdm,
      fields: route.params.fields,
      approvalWorkflows: route.params.approverWorkflow,
    }),
  },
  {
    path: '/cdmrs/:cdmrId',
    name: 'editCdmr',
    component: () => lazyLoadView(import('@views/editCdmr')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          .dispatch('cdmrs/getCdmr', { cdmrId: routeTo.params.cdmrId })
          .then(result => {
            // Add the settings to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.cdmr = result.cdmr
            routeTo.params.fields = result.fields
            routeTo.params.changesets = result.changesets

            store.dispatch('approverWorkflow/getApprovers').then(result => {
              routeTo.params.approverWorkflow = result
              // Continue to the route.
              next()
            })
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'CDM' } })
          })
      },
    },
    // Set the settings from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({
      initialCdmr: route.params.cdmr,
      fields: route.params.fields,
      initialChangesets: route.params.changesets,
      approverWorkflow: route.params.approverWorkflow,
    }),
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
    },
    props: route => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/profile/:user_id',
    name: 'username-profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store
          // Try to fetch the user's information by their user_id
          .dispatch('users/fetchUser', { userId: routeTo.params.user_id })
          .then(user => {
            // Add the user to the route params, so that it can
            // be provided as a prop for the view component below.
            routeTo.params.user = user
            // Continue to the route.
            next()
          })
          .catch(() => {
            // If a user with the provided username could not be
            // found, redirect to the 404 page.
            next({ name: '404', params: { resource: 'User' } })
          })
      },
    },
    // Set the user from the route params, once it's set in the
    // beforeResolve route guard.
    props: route => ({ user: route.params.user }),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          route => route.meta.authRequired
        )
        // Navigate back to previous page, or login as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'login' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => lazyLoadView(import('@views/reports')),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        next()
      },
    },
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
